import { React } from 'react';
import { Container, Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Typewriter from 'typewriter-effect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPeace } from '@fortawesome/free-solid-svg-icons';

import MotionDesignImg from './ui/Motion';
// import ContactMeDesignImg from "./ui/contactMe";
// import { FaLinkedinIn } from "react-icons/fa";
import Particle from '../Particle';
import ContactMe from '../ContactMe';
import About from '../AboutMe/About';
function Home() {
  return (
    <>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="home-row">
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading homeFont">
                Hello..!{' '}
              </h1>

              <h1
                style={{
                  color: '#FFC107',
                  textShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
                }}
                className="heading-name homeFont HomeName"
              >
                I'm <strong className="main-name">Sumanth Nandeti </strong>
                <FontAwesomeIcon
                  style={{
                    color: '#FFC107',
                    textShadow: 'rgba(0, 0, 0, 0.3) 2px 2px 5px',
                  }}
                  icon={faHandPeace}
                />
              </h1>

              <div
                style={{
                  textAlign: 'left',
                  fontSize: '2.5rem',
                  color: 'rgb(17, 121, 247)',
                  fontWeight: 100,
                }}
              >
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString('Software Developer')
                      .pauseFor(200)
                      .deleteAll()
                      .typeString('Web Developer')
                      .pauseFor(200)
                      .deleteAll()
                      .typeString('UI/UX Designer')
                      .pauseFor(200)
                      .deleteAll()
                      .typeString('Front End Developer')
                      .pauseFor(200)
                      .deleteAll()
                      .typeString('Java Developer')
                      .pauseFor(200)
                      .start();
                  }}
                  options={{
                    autoStart: true,
                    loop: true,
                  }}
                />
              </div>
              <div
                style={{
                  background:
                    'linear-gradient(to right, rgb(97, 165, 194), rgb(0 0 0))',
                  color: 'white',
                  borderRadius: '1rem',
                  padding: '10px',
                  marginBottom: '10px',
                }}
              >
                <p
                  style={{
                    fontSize: '1.2rem',
                    padding: '5px',
                  }}
                >
                  Engineer and passionate Front End Developer with 5+ years of professional
                  experience writing clean and standard code in JavaScript using
                  modern frameworks like SAP Fiori,SAPUI5 and Angular, React, NextJS
                </p>
              </div>

              {/* <div className="skills-icons-div HomelogoHbox">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="GitHubTooltip">
                    <strong>GitHub</strong>
                  </Tooltip>
                }
              >
                <a
                  href="https://github.com/sumanthn3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub
                    className="iconSize borderIconHome"
                    style={{ color: "white", fontSize: "24px" }}
                  />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="TwitterTooltip">
                    <strong>Twitter</strong>
                  </Tooltip>
                }
              >
                <a
                  href="https://www.linkedin.com/in/sumanthnandeti/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter
                    className="iconSize borderIconHome"
                    style={{ color: "#1DA1F2", fontSize: "24px" }}
                  />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="LinkedinTooltip">
                    {" "}
                    <strong>LinkedIn</strong>
                  </Tooltip>
                }
              >
                <a
                  href="https://www.linkedin.com/in/sumanthnandeti/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin
                    className="iconSize borderIconHome"
                    style={{ color: "#1DA1F2", fontSize: "24px" }}
                  />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="instaTooltip">
                    <strong>Instagram</strong>
                  </Tooltip>
                }
              >
                <a
                  href="https://www.instagram.com/sumanthnandeti"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram
                    className="iconSize borderIconHome"
                    style={{ color: "#E4405F", fontSize: "24px" }}
                  />
                </a>
              </OverlayTrigger>
            </div> */}
            </Col>

            <Col md={3} className="myPic">
              <div className="wavy myPic"></div>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="motion-img-container">
              <MotionDesignImg />
            </Col>
          </Row>
          <About />
          <ContactMe />
        </Container>
      </Container>
    </>
  );
}

export default Home;
